import React, { useState } from 'react';
import Button from '@techsoftware/happay-widgets/Button';
import Grid from '@techsoftware/happay-widgets/Grid';
import './index.scss';
import { withRouter } from 'react-router';
import TextInput from '@techsoftware/happay-widgets/TextInput';
import ActionConfirmation from '../ActionConfirmation';

function BottomActions({
  handleActionClick,
  submitDisabled = false,
  from,
  viewType,
  history,
  validation,
  actionMap = {},
  showCommentField,
  invoiceDetails = {},
  currencyList = [],
  showCancelConfirmation = false,
  isRequesterApproverDiff,
  disabled = false,
  handleCancel,
}) {
  const [state, setState] = useState({});

  const handleBottomActionClick = val => {
    const {
      location: { state: { prevPath = '' } = {} } = {},
      push,
      go,
    } = history;
    const valid = ['Cancel', 'Save', 'Decline'].includes(val)
      ? true
      : !validation
      ? true
      : validation(val);
    if (from === 'Bulk Vendors' && showCancelConfirmation && val === 'Cancel') {
      handleCancel();
    } else if (!showCancelConfirmation && val === 'Cancel') {
      if (!prevPath) {
        go(-1);
      } else {
        push(prevPath);
      }
    } else if (
      valid &&
      !['Save', 'Preview', 'Reschedule Payment', 'Cancel Payment'].includes(val)
    ) {
      setState({
        ...state,
        openDialogbox: true,
        typeOfAction: val,
      });
    } else if (
      ['Save', 'Reschedule Payment', 'Cancel Payment'].includes(val) &&
      valid
    ) {
      handleActionClick(val);
    } else if (val === 'Preview') {
      handleActionClick(val);
    }
  };

  const handleDialogActionClick = val => {
    const { location: { state: { prevPath = '' } = {} } = {}, push } = history;
    if (state.typeOfAction === 'Cancel') {
      push(prevPath);
      setState({ openDialogbox: false });
    } else {
      setState({ openDialogbox: false });
      handleActionClick(typeOfAction, state.comment, state.approvedAmount);
    }
  };

  const drawActionMap = () => {
    const buttonMap = [];
    for (const key in actionMap) {
      buttonMap.push(
        <Button
          type="button"
          text={key}
          variant={
            ['Save', 'Decline', 'Cancel Payment'].includes(key)
              ? 'secondary'
              : 'primary'
          }
          className="margin-l-20"
          disabled={(key === 'Submit' && submitDisabled) || disabled}
          onClick={() => handleBottomActionClick(key)}
        />,
      );
    }
    return buttonMap;
  };

  const drawDialogBody = () => {
    const { invoice: { amount = '', currency } = {} } = invoiceDetails;
    const curr = currencyList.find(el => el.text === currency)?.value;
    const isBulkVendors = from === 'Bulk Vendors';
    return (
      <>
        {`Are you sure you want to ${typeOfAction?.toLowerCase()} the ${
          isBulkVendors ? 'bulk vendors' : from
        }?`}
        {showCommentField && typeOfAction !== 'Cancel' && (
          <TextInput
            floatingLabelText="Remark"
            type="textarea"
            onChange={(event, value) => {
              setState({ ...state, comment: value });
            }}
            value={state.comment}
            clearMargin
            hintText="Enter comment"
            customInputParentStyle={{ marginTop: '34px' }}
          />
        )}
      </>
    );
  };

  const breakPoint =
    from === 'Invoice'
      ? 24
      : ['Vendor', 'Bulk Vendors'].includes(from)
      ? 16
      : 22;
  const { openDialogbox, typeOfAction } = state;
  const isBulkVendors = from === 'Bulk Vendors';
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className="bottom-actions"
    >
      {!['Save', 'Preview'].includes(typeOfAction) && (
        <ActionConfirmation
          btn2Action={handleDialogActionClick}
          openDialogbox={openDialogbox}
          onDialogboxClose={() => setState({ ...state, openDialogbox: false })}
          dialogTitle={` ${typeOfAction} ${
            ['editinvoice', 'detail'].includes(viewType) || isBulkVendors
              ? ''
              : 'New'
          } ${from} `}
          dialogBody={drawDialogBody()}
          showCommentField={showCommentField}
        />
      )}

      <Grid
        item
        container
        justify="space-between"
        xs={22}
        sm={22}
        md={breakPoint}
        lg={breakPoint}
        xl={breakPoint}
        className={from === 'Invoice' ? 'padding-lr-70' : ''}
      >
        <Button
          type="button"
          text="Cancel"
          variant="tertiary"
          className="margin-r-20"
          onClick={() => handleBottomActionClick('Cancel')}
        />
        {(isRequesterApproverDiff && viewType === 'detail') ||
        viewType !== 'detail' ? (
          <div>{drawActionMap()}</div>
        ) : null}
      </Grid>
    </Grid>
  );
}

export default withRouter(BottomActions);
